import * as General from './general';

export const generalActions = General;
